import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './SortDropdown.css';
import React, { useRef } from 'react';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import IconChevronDown from '../../resources/icons/IconChevronDown.svg';
import IconChevronDownYellow from '../../resources/icons/IconChevronDownYellow.svg';
import { removeQueryString, default as addQueryString, splitter, addQuerySorting, removeQuerySortingString } from './index';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';

// let facetFilters: any = convertQueryParamsToFacets(queryParams);

var SortDropdown = function SortDropdown(_ref) {
  var fields = _ref.fields,
    hideLabel = _ref.hideLabel,
    hideAmount = _ref.hideAmount,
    dictionary = _ref.dictionary,
    showLabel = _ref.showLabel,
    selectAllLabel = _ref.selectAllLabel,
    resultsLabel = _ref.resultsLabel,
    clearAllLabel = _ref.clearAllLabel,
    buttonYellow = _ref.buttonYellow,
    openWithWrapper = _ref.openWithWrapper,
    keepOpenOnChange = _ref.keepOpenOnChange,
    widgetAnalytics = _ref.widgetAnalytics,
    facets = _ref.facets,
    nbHits = _ref.nbHits,
    setFilter = _ref.setFilter,
    facetsName = _ref.facetsName,
    indexDropDown = _ref.indexDropDown,
    firstQuery = _ref.firstQuery,
    firstFilter = _ref.firstFilter,
    wrapperToggle = _ref.wrapperToggle,
    defaultFacets = _ref.defaultFacets,
    hideDesktopShowButton = _ref.hideDesktopShowButton,
    hideShowButton = _ref.hideShowButton,
    setSubpanelLabel = _ref.setSubpanelLabel,
    onChangeCallback = _ref.onChangeCallback,
    onToggleCallback = _ref.onToggleCallback,
    clearAlllFilters = _ref.clearAlllFilters,
    analytics = _ref.analytics,
    getFilterValue = _ref.getFilterValue,
    resetAllFiltersCallback = _ref.resetAllFiltersCallback,
    searchIndex = _ref.searchIndex,
    _ref$columnsClass = _ref.columnsClass,
    columnsClass = _ref$columnsClass === void 0 ? 'col-md-4' : _ref$columnsClass;
  var location = useLocation();
  var queryParams = qsToObject(location.search);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setisOpen = _React$useState2[1];
  var filterName = get(fields, 'name');
  var label = get(fields, 'title.jss.value');
  var tagsToDisplay = get(fields, 'tagsToDisplay.values');
  var showSelectAllOption = get(fields, 'showSelectAllOption.jss.value');
  var selectedTagsToDisplay = get(fields, 'preselectedTags.values') || [];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    filteredOptions = _React$useState4[0],
    setfilteredOptions = _React$useState4[1];
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    filteredLabel = _React$useState6[0],
    setfilteredLabel = _React$useState6[1];
  var checkboxes = /*#__PURE__*/React.createRef();
  var history = useHistory();
  var type = 'radio';
  var filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  var rootRef = useRef();
  var mapDictionary = {
    'distanceDWC': 'search.distanceFromAlMaktoumIntAirport',
    'distanceDXB': 'search.distanceFromDubaiInternationalAirport'
  };
  var createFacets = function createFacets(tagsToDisplay, facets) {
    var filteredOptions = [];
    if (facets) {
      filteredOptions = facets.map(function (item) {
        return {
          key: item.fieldName.value,
          label: getDictionaryItem(dictionary, mapDictionary[item.fieldName.value]),
          name: item.fieldName.value
        };
      });
    }
    return filteredOptions;
  };
  var toggleFilter = function toggleFilter() {
    setisOpen(!isOpen);
    wrapperToggle(isOpen);
  };
  var clearFilter = function clearFilter(e) {
    setisOpen(false);
    setfilteredLabel('');
    setFilter();
    wrapperToggle(true, false);
    removeQuerySortingString(facetsName, history, searchIndex);
    var checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
    for (var i = 0; i <= checkboxesArray.length - 1; i++) {
      checkboxesArray[i].checked = false;
    }
    getFilterValue && getFilterValue(fields.name, facetsName, null);
    if (e) {
      e.stopPropagation();
    }
  };
  var setChecked = function setChecked(checkboxes) {
    var setfilteredLabelArray = [];
    var queries = queryParams["".concat(filterType)];
    var checkboxesArray = checkboxes.querySelectorAll('.input-choice');
    queries && queries.split(splitter).map(function (item) {
      for (var i = 0; i <= checkboxesArray.length - 1; i++) {
        // checkboxesArray[i].checked = false;
        if (checkboxesArray[i].value === item.split('+').join(' ')) {
          checkboxesArray[i].checked = true;
          if (setfilteredLabelArray.length === 0) {
            setfilteredLabelArray.push(checkboxesArray[i].value);
          } else {
            setfilteredLabelArray.push(', ' + checkboxesArray[i].value);
          }
        }
      }
    });
    if (setfilteredLabelArray.length !== 0) {
      setfilteredLabel(setfilteredLabelArray);
    } else {
      setfilteredLabel('');
    }
  };
  React.useEffect(function () {
    if (firstFilter) {
      setfilteredOptions(createFacets(tagsToDisplay, defaultFacets));
    }
    if (filterType === firstQuery) {} else {
      setfilteredOptions(createFacets(tagsToDisplay, facets));
    }
  }, [facets, defaultFacets]);
  React.useEffect(function () {
    if (clearAlllFilters) {
      if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
        var preselectedTags = selectedTagsToDisplay.map(function (tag) {
          return get(tag, 'title.value') || get(tag, 'name');
        });
        facetsName.forEach(function (f) {
          return addQueryString(f, preselectedTags.join(','), history);
        });
        setFilter();
        resetAllFiltersCallback();
      } else {
        clearFilter();
      }
    }
  }, [clearAlllFilters]);
  React.useEffect(function () {
    setChecked(checkboxes.current);
  }, [filteredOptions, facets]);
  var submitFilters = function submitFilters(e, facetsName) {
    createFacets(tagsToDisplay, defaultFacets);
    var checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
    var selected = {};
    filteredOptions.forEach(function (_ref2) {
      var key = _ref2.key,
        label = _ref2.label,
        name = _ref2.name;
      selected[key] = false;
    });
    var selectedCheckboxes = [];
    for (var i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selected[checkboxesArray[i].value] = true;
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
    }
    setFilter(true, undefined, selectedCheckboxes);
    // selectedCheckboxes = selectedCheckboxes.toString();
    !!selectedCheckboxes.length && setfilteredLabel(selectedCheckboxes.map(function (v) {
      return getDictionaryItem(dictionary, mapDictionary[v]);
    }));
    if (!keepOpenOnChange) {
      setisOpen(false);
    }
    getFilterValue && getFilterValue(fields.name, facetsName, selected);
    addQuerySorting(facetsName, selected, history, searchIndex);
    e.stopPropagation();
  };
  var closeDropdwn = function closeDropdwn(event) {
    if (event.target.closest) {
      if (event.target.closest('.filter__field') !== rootRef.current && !event.target.closest('.filter__header')) {
        setisOpen(false);
        wrapperToggle(true);
      } else if (event.target.closest('.filter__header-links')) {
        setisOpen(false);
        wrapperToggle(true);
      }
    } else {
      setisOpen(false);
      wrapperToggle(true);
    }
  };
  React.useEffect(function () {}, [facets]);
  React.useEffect(function () {
    var queries = queryParams["".concat(filterType)];
    if (!queries && selectedTagsToDisplay.length) {
      var preselectedTags = selectedTagsToDisplay.map(function (tag) {
        return get(tag, 'title.value') || get(tag, 'name');
      });
      facetsName.forEach(function (f) {
        return addQueryString(f, preselectedTags.join(','), history);
      });
      setFilter(true);
    }
    document.body.addEventListener('click', closeDropdwn);
    return function () {
      facetsName.forEach(function (f) {
        return removeQueryString(f, history);
      });
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field filter__field-dropdown sort-dropdown",
    ref: rootRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel eloqua ".concat(isOpen ? 'filter-panel--open' : '')
  }, hideLabel ? null : /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    className: "filter-panel__box ".concat(isOpen ? 'filter-panel__box--openedDrop' : ''),
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        event.preventDefault();
        event.target.click();
      }
    },
    onClick: function onClick() {
      onToggleCallback && onToggleCallback();
      if (openWithWrapper) {
        toggleFilter();
      } else {
        setisOpen(!isOpen);
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-panel__trigger js-filter-panel__trigger"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, filteredLabel ? filteredLabel : label), /*#__PURE__*/React.createElement("img", {
    className: "icon",
    src: buttonYellow ? IconChevronDownYellow : IconChevronDown,
    alt: "smth"
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, clearAllLabel ? /*#__PURE__*/React.createElement("div", {
    className: "fp__inner-cb"
  }, showSelectAllOption ? /*#__PURE__*/React.createElement("span", {
    className: "body-medium fp__inner-clear cursor-pointer",
    onClick: function onClick(e) {
      var inputs = checkboxes.current.querySelectorAll('.input-choice');
      inputs.forEach(function (input) {
        input.checked = true;
      });
      wrapperToggle(true);
      submitFilters(e, facetsName);
    }
  }, selectAllLabel ? selectAllLabel : '') : /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("button", {
    className: "body-medium fp__inner-clear cursor-pointer btn--reset",
    onClick: function onClick(e) {
      clearFilter(e);
      !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
    },
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13) {
        e.preventDefault();
        clearFilter(e);
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
      }
    }
  }, clearAllLabel)) : null, /*#__PURE__*/React.createElement("div", {
    ref: checkboxes
  }, filteredOptions.map(function (item, index) {
    var key = item.key,
      label = item.label,
      name = item.name;
    return /*#__PURE__*/React.createElement("label", {
      className: "checkbox-aligned fp__inner-label",
      htmlFor: key.replace(/\s/g, '_'),
      key: index
    }, /*#__PURE__*/React.createElement("input", {
      className: "input-choice ".concat(type === 'radio' ? 'fp__radio' : 'fp__checkbox'),
      type: type
      //defaultChecked={setChecked(key, filterType)}
      ,

      name: "dropdown=".concat(indexDropDown),
      value: key,
      onChange: function onChange(e) {
        onChangeCallback && onChangeCallback();
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), "".concat(filterName, ": ").concat(name ? name : key));
        if (hideDesktopShowButton) {
          if (canUseDOM && window.innerWidth >= 768) {
            submitFilters(e, facetsName);
            wrapperToggle(true);
          }
        } else if (hideShowButton) {
          submitFilters(e, facetsName);
          wrapperToggle(true);
        }
      },
      id: key.replace(/\s/g, '_')
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, label), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-bg"
    }));
  }))), !hideDesktopShowButton || !hideShowButton ? /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    onClick: function onClick(e) {
      wrapperToggle(true);
      submitFilters(e, facetsName);
      !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterShowResultsAnalytics, analytics.params));
    }
  }, showLabel, " ", resultsLabel)) : null))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    columnsClass = _ref3.columnsClass;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(columnsClass)
  }, children);
};

// export default SortDropdown;
export default SortDropdown;
var commonStyles = "c126wcpz";